<template>
  <div class="mb-16 font-normal">
    <h2 class="custom-title custom-color-gray font-medium mb-4">
      {{ $t('message.abm.folders.settings.visibleDocuments.question') }}
    </h2>
    <p class="custom-legend text-zt-dark-300 mb-4">
      {{ $t('message.abm.folders.settings.visibleDocuments.description') }}
    </p>
    <div class="w-full radio-group">
      <zt-radio-button
        :value="'true'"
        v-model="selected"
        name="visible"
        @change="update"
        data-vs-radio-button="visibleDocuments"
      >
        <span class="custom-label">{{ $t('message.abm.folders.settings.visibleDocuments.option.label') }}</span>
      </zt-radio-button>
      <span class="radio-legend block text-zt-dark-300">
        {{ $t('message.abm.folders.settings.visibleDocuments.option.legend') }}
      </span>
    </div>
    <div class="w-full">
      <zt-radio-button
        :value="'false'"
        v-model="selected"
        name="visible"
        @change="update"
        data-vs-radio-button="visibleDocuments"
      >
        <span class="custom-label">{{ $t('message.abm.folders.settings.visibleDocuments.option1.label') }}</span>
      </zt-radio-button>
      <span class="radio-legend block text-zt-dark-300">
        {{ $t('message.abm.folders.settings.visibleDocuments.option1.legend') }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VisibleDocuments',
  inject: ['stateFolder', 'setParams'],
  data() {
    return {
      selected: ''
    }
  },
  created() {
    this.selected = this.stateFolder.params.visible.toString()
  },
  methods: {
    update() {
      /*
        Si selecciona “No requiere firma” y “Sí, son visibles”
        Requiere firma = false
        Visible = true
        Efímero = false

        Si selecciona “No requiere firma” y “No, ocultarlos”
        Requiere firma = false
        Visible = false
        Efímero = false
      */
      const visible = (/^(true|1)$/i).test(this.selected) && !!this.selected
      this.setParams({
        ephemeral: false,
        visible
      })
    }
  }
}
</script>

<style scoped lang="scss">
.custom-color-gray {
  color: #575757;
}
.custom-title {
  font-size: 1.5rem;
}
.custom-legend {
  font-size: 1.125rem;
}
.custom-label {
  font-size: 1.25rem;
  line-height: 1;
  color: #000;
}
.radio-legend {
  margin-left: calc(24px + 1rem);
  line-height: 1;
}
::v-deep {
  .zt-input-radiobutton {
    label {
      padding-top: 3px;
    }
    i {
      font-size: 1.5rem;
      line-height: 1;
    }
  }
}
</style>